const errorParser = (payload, location = 'Not Set') => {
  // Collect information about what went wrong in sentry
  console.error({ location, error: payload });

  if (payload && payload.detail) {
    if (Array.isArray(payload.detail)) {
      return payload.detail.join(', ');
    }
    return payload.detail;
  }

  return 'Something went wrong. Try again.';
};

export default errorParser;
